// extracted by mini-css-extract-plugin
module.exports = {"svgIcon":"styles_svgIcon__3ELFQ","icons":"styles_icons__36wy_","ListHeading":"styles_ListHeading__1EL9Q","tableLink":"styles_tableLink__2KlSb"};